import { IPulseXConfig } from "@pulsex/types";
const pulseConfig: IPulseXConfig = {
    CLIENT_ID: "mdnen",
    CLIENT_NAME: "Al Mayadeen English",
    showClientNameInMetaData: true,
    API_URL: "https://public-api-en.almayadeen.net",
    SEARCH_URL: "https://mdn-search.mangopulse.net/mangopulse",
    MEDIA_URL: "https://media-en.mangopulse.net",
    CLIENT_URL: "https://english.almayadeen.net",
    weatherApiKey: "cf681607a7c35bd1bac01b122bf3308c",
    TRACKER_BASE_URL: "track-en.almayadeen.net",
    cropRatios: {
        rectangle: 1,
        standard: 2,
        square: 3,
        vertical: 4,
        standard2: 5,
    },
    cropSizes: {
        "1": 1.7,
        "2": 1.2,
        "3": 1,
        "4": 0.5937,
        "5": 1.4,
    },
    // TODO: edit this to the real date
    sitemapStartingDate: "2024-10-01",
    QUERY_KEYS: {
        GET_PAGE: "GET_PAGE",
        GET_ASSETS: "GET_ASSETS",
    },
};

export default pulseConfig;
